// R4's handle (people-create-door T8e): David decides a pilot value the PHF sync
// held for him (a pilot_form_differs queue item). routes/tracon-form-differs.routes.js.
// The refusals the caller toasts itself are expected, so api.js does not toast twice.
import { api } from '@/lib/api.js';

const ANSWERS = [
  { status: 409, code: 'stale' },
  { status: 409, code: 'already_decided' },
  { status: 409, code: 'wrong_kind' },
  { status: 409, code: 'flag_incomplete' },
  { status: 404, code: 'not_found' },
  { status: 409, code: 'people_not_authoritative' },
  { status: 503, code: 'write_store_unreadable' },
  { status: 400, code: 'invalid_value' },
];

// Keep mine: the record keeps its value; this same form value is not flagged again.
export function keepRecordValue(id) {
  return api.post(`/api/tracon/form-differs/${encodeURIComponent(id)}/keep`, {}, { expected: ANSWERS });
}

// Use the pilot's: the form's value goes on the record (TRACON and Zoho), stated by David.
// body { keep_old_as: label } on a phone flag keeps the record's old number as another number (AR35).
export function adoptPilotValue(id, body = {}) {
  return api.post(`/api/tracon/form-differs/${encodeURIComponent(id)}/adopt`, body, { expected: ANSWERS });
}
